import Analytics from "./Analytics";
import ChatActions from "../../actions/ChatActions";
import { EVENT_ACTIONS } from "../../constants/AnalyticsConstants";
import ResponseStore from "../../stores/chat/ResponseStore";
import QuestionStore from "../../stores/chat/QuestionStore";
import QuickReplyType from "../../constants/ChatAutoResponseQuickReplyTypes";

export default {
    acceptAutoResponse() {
        const question = QuestionStore.getQuestion();
        const autoResponse = ResponseStore.getCurrentResponse();

        Analytics.sendGaEvent({ action: EVENT_ACTIONS.AutoResponseAccepted });

        ChatActions.autoResponseReply({
            autoResponseId: autoResponse.id,
            questionUuid: question.uuid,
            quickReply: QuickReplyType.ACCEPTED,
        });
    },

    dismissAutoResponse() {
        const autoResponse = ResponseStore.getCurrentResponse();
        const question = QuestionStore.getQuestion();

        Analytics.sendGaEvent({ action: EVENT_ACTIONS.AutoResponseRejected });

        ChatActions.autoResponseReply({
            autoResponseId: autoResponse.id,
            questionUuid: question.uuid,
            quickReply: QuickReplyType.REJECTED,
        });
    },

    acceptMarkAsResolved() {
        const question = QuestionStore.getQuestion();
        const message = ResponseStore.getMarkAsResolvedMessage();

        ChatActions.reviewMarkAsResolved({
            confirm: true,
            messageId: message.id,
            questionUuid: question.uuid,
        });
    },

    rejectMarkAsResolved() {
        const question = QuestionStore.getQuestion();
        const message = ResponseStore.getMarkAsResolvedMessage();

        ChatActions.reviewMarkAsResolved({
            confirm: false,
            messageId: message.id,
            questionUuid: question.uuid,
        });
    },

    dismissActionBar() {
        ChatActions.clearActionBar();
    },
};
